import { createUserModalStyles } from "@insite/content-library/Widgets/UserList/CreateUserModal";
import { css } from "styled-components";

createUserModalStyles.submitButton = {
    mergeCss: true,
    css: css`
        margin-left: 1rem;
    `,
};
